import { render, staticRenderFns } from "./IFrameRouter.vue?vue&type=template&id=8f676bf8"
import script from "./IFrameRouter.vue?vue&type=script&lang=js"
export * from "./IFrameRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports